<div class="dialog-container">
  <h1 mat-dialog-title>Select a transit warehouse</h1>

  <div mat-dialog-content>
    <mat-form-field class="transit-warehouses-select">
      <app-mat-select [(ngModel)]="selectedId" filterKey="name" (selectionChange)="onChange($event)">
        <mat-option [value]="null">-</mat-option>
        <mat-option *appMatSelectFor="let s of transitWarehouses" [value]="s.id">{{ s.code }} - {{ s.name }}</mat-option>
      </app-mat-select>
    </mat-form-field>
  </div>

  <div mat-dialog-actions>
    <div class="row width-100per">
      <div class="col-md-12 text-center width-100per margin-bottom-10">
        <mat-checkbox class="tws-checkbox" *ngIf="transitWarehouseTws" (change)="onClick($event)">Are you sure?</mat-checkbox>
      </div>
      <div class="col-md-12 text-center width-100per">
        <button class="btn-product save-button" [disabled]="!transitWarehouseTwsCheck" (click)="onSubmit()">Save</button>
        <button class="btn-product" (click)="onClose()">Cancel</button>
      </div>
    </div>
  </div>
</div>
